class coneDrawing {
	
	constructor()
		{
			this.touchCenter = false;
			this.conePositions = {'center': {'x': 0, 'y': 0}};
		}
	
	addCones(alreadyDrawnCone, alreadyDrawnConeDiagonal, linePoint, coneAttributes, coneAttributesDiag, canvasW, canvasH, coneSize, id, newConesSize) {
		this.touchCenter = false;
		
		let coneSizeSmall = newConesSize['newConeSmall'];
		let coneSizeBig = newConesSize['newConeBig'];
		let smallConeDiffW = coneSizeSmall[0] - coneSize[0]/2;
		let smallConeDiffH = coneSizeSmall[1] - coneSize[1]/2;
		let bigConeDiffW = coneSizeBig[0] - coneSize[0]/2;
		let bigConeDiffH = coneSizeBig[1] - coneSize[1]/2;
		
		if ( ( alreadyDrawnCone && window['globalActType'] == 'lateralCone' ) || ( alreadyDrawnConeDiagonal && window['globalActType'] == 'diagonalCone' ) )
			{
				
				if ( window['globalActType'] == 'lateralCone' )
					{
						this.conePositions['center']['x'] = (coneAttributes['rightConeStartX']-coneAttributes['leftConeStartX'])+(coneAttributes['rightConeWidth']+2);
						this.conePositions['center']['y'] = coneAttributes['leftConeStartY']+(coneAttributes['leftConeHeight']/2);
						
						linePoint.push({'t': 'cone', 'startX': coneAttributes['rightConeStartX'], 'startY': coneAttributes['rightConeStartY'], 'w': coneAttributes['rightConeWidth'], 'h': coneAttributes['rightConeHeight'], 'side': 'r'});
						linePoint.push({'t': 'cone', 'startX': coneAttributes['leftConeStartX'], 'startY': coneAttributes['leftConeStartY'], 'w': coneAttributes['leftConeWidth'], 'h': coneAttributes['leftConeHeight'], 'side': 'l'});
					}
				else
					{
						this.conePositions['center']['x'] = (coneAttributesDiag['rightConeStartX']-coneAttributesDiag['leftConeStartX'])+(coneAttributesDiag['rightConeWidth']+2);
						this.conePositions['center']['y'] = coneAttributesDiag['leftConeStartY']+(coneAttributesDiag['leftConeHeight']/2);
						
						linePoint.push({'t': 'cone_diagonal', 'startX': coneAttributesDiag['rightConeStartX'], 'startY': coneAttributesDiag['rightConeStartY'], 'w': coneAttributesDiag['rightConeWidth'], 'h': coneAttributesDiag['rightConeHeight'], 'side': 'r'});
						linePoint.push({'t': 'cone_diagonal', 'startX': coneAttributesDiag['leftConeStartX'], 'startY': coneAttributesDiag['leftConeStartY'], 'w': coneAttributesDiag['leftConeWidth'], 'h': coneAttributesDiag['leftConeHeight'], 'side': 'l'});
					}
			}
		else
			{
				this.conePositions['center']['x'] = canvasW/2;
				this.conePositions['center']['y'] = canvasH-coneSize[1]/2;
				
				if ( window['globalActType'] == 'lateralCone' )
					{
						linePoint.push({'t': 'cone', 'startX': canvasW-(canvasW*0.1)-coneSizeBig[0], 'startY': canvasH-(coneSizeBig[1]*0.75), 'w': coneSizeBig[0], 'h': coneSizeBig[1], 'side': 'r'});
						linePoint.push({'t': 'cone', 'startX': canvasW*0.1, 'startY': canvasH-(coneSizeBig[1]*0.75), 'w': coneSizeBig[0], 'h': coneSizeBig[1], 'side': 'l'});
					}
				else
					{
						linePoint.push({'t': 'cone_diagonal', 'startX': canvasW-(canvasW*0.1)-coneSizeBig[0], 'startY': canvasH-(coneSizeBig[1]*0.75), 'w': coneSizeBig[0], 'h': coneSizeBig[1], 'side': 'r'});
						linePoint.push({'t': 'cone_diagonal', 'startX': canvasW*0.1, 'startY': canvasH-(coneSizeBig[1]*0.75), 'w': coneSizeBig[0], 'h': coneSizeBig[1], 'side': 'l'});
					}
			}
		
		window['canvasLines'+id] = linePoint;
		
		if ( window['globalActType'] == 'lateralCone' )
			{
				if ( window['workoutAreaSetupDone'+id] && !alreadyDrawnCone )
					{
						this.placeConesInZone(id);
					}
			}
		
		if ( window['globalActType'] == 'diagonalCone' )
			{
				if ( window['workoutAreaSetupDone'+id] && !alreadyDrawnConeDiagonal )
					{
						this.placeDiagConesInZone(id);
					}
			}
		
		return linePoint;
	}
	
	addSingleCone(linePoint, canvasW, canvasH, coneSize) {
		linePoint.push({'t': 'cone', 'startX': canvasW-coneSize[0]/2, 'startY': canvasH-coneSize[1]/2, 'w': coneSize[0]/2, 'h': coneSize[1]/2});		
	
		return linePoint;
	}
	
	conesDistance(ctx, item, item2, linesWidth, strokeColor, canvasW, coneLineDist) {
		var distLineW = coneLineDist ? coneLineDist : (item.startX - (canvasW - item.startX));
		
		var rectItem = {
			'startX' : canvasW - item.startX,
			'startY' : item.startY,
			'w' : distLineW,
			'h' : item.h
		};
		console.log(window['globalActType'], 'globalActType');
		ctx.beginPath();
		if ( window['globalActType'] == 'lateralCone' ) { ctx.moveTo(canvasW - item.startX - item.w/2, item.startY+(item.h*0.8)); }
		else { ctx.moveTo(item2.startX + item2.w/2, item2.startY+(item2.h*0.8)); }
		ctx.lineTo(item.startX + item.w/2, item.startY+(item.h*0.8));
		ctx.lineWidth = linesWidth;
		ctx.strokeStyle = strokeColor;
		ctx.stroke();
		ctx.closePath();
		
		var rectSize = window.calcHeight(rectItem);
		
		if ( rectSize['h'] > 0 )
			{
				var sizeText = window.inToFt(rectSize['w']);
				
				var textStructure = {'text': sizeText, 'startX': canvasW/2 - 15, 'startY': item.startY + item.h/2, 'font': 'bold 25px Arial', 'strokeColor': '#000', 'fillStyle': strokeColor, 'lineWidth': 4};								
				window.elementDraw.writeText(ctx, textStructure);
			}
	}
	
	singleConeLines(ctx, item, lineWidth) {
		var singleLineWidth = lineWidth <= 9 ? lineWidth : 9; 
		
		ctx.beginPath();
		ctx.moveTo(item.startX-50*item['sizeUp']-singleLineWidth, item.startY+(item.h*0.75));
		ctx.lineTo(item.startX+item.w+50*item['sizeUp']+singleLineWidth, item.startY+(item.h*0.75));
		ctx.moveTo(item.startX+item.w/2, item.startY+(item.h*0.75));
		ctx.lineTo(item.startX+item.w/2, item.startY+item.h+50*item['sizeUp']);
		ctx.lineWidth = singleLineWidth;
		ctx.strokeStyle = window.currentUserData.whiteboardValues.outsideBoxColor;
		ctx.stroke();
		ctx.closePath();
	}
	
	addWorkoutCones(linePoint, canvasW, canvasH) {
		/* let coneSizeSmall = newConesSize['newConeSmall'];
		let coneSizeBig = newConesSize['newConeBig'];
		let smallConeDiffW = coneSizeSmall[0] - coneSize[0]/2;
		let smallConeDiffH = coneSizeSmall[1] - coneSize[1]/2;
		let bigConeDiffW = coneSizeBig[0] - coneSize[0]/2;
		let bigConeDiffH = coneSizeBig[1] - coneSize[1]/2;
		 */
		let workoutAreaObject = this.activityBuilderContent.activityBuilderObject['workoutAreaSetup'];
		let workoutCones = workoutAreaObject['drawingObjects'];
		let coneSize = [workoutCones[0]['defaultWidth'], workoutCones[0]['defaultHeight']];
		var mainthis = this;
		
		window['useEquipmentLocation'] = false;
		
		if ( window['workoutConePlacing'] && window['useEquipmentLocation'] )
			{
				/* linePoint.push({'t': 'cone', 'startX': window['workoutConePlacing']['topRight']['posX'] - (coneSizeSmall[0]/2), 'startY': window['workoutConePlacing']['topRight']['posY'] - (coneSizeSmall[1]), 'w': coneSizeSmall[0], 'h': coneSizeSmall[1], 'conePos': 'topRight', 'hidden': false, 'workoutCone': true});
				linePoint.push({'t': 'cone', 'startX': window['workoutConePlacing']['topLeft']['posX'] + (coneSizeSmall[0]/2), 'startY': window['workoutConePlacing']['topLeft']['posY'] - (coneSizeSmall[1]), 'w': coneSizeSmall[0], 'h': coneSizeSmall[1], 'conePos': 'topLeft', 'hidden': true, 'workoutCone': true});
				linePoint.push({'t': 'cone', 'startX': window['workoutConePlacing']['bottomLeft']['posX'] - (coneSizeBig[0]/2), 'startY': window['workoutConePlacing']['bottomLeft']['posY'] - (coneSizeBig[1]), 'w': coneSizeBig[0], 'h': coneSizeBig[1], 'conePos': 'bottomLeft', 'hidden': true, 'workoutCone': true});
				linePoint.push({'t': 'cone', 'startX': window['workoutConePlacing']['bottomRight']['posX'] + (coneSizeBig[0]/2), 'startY': window['workoutConePlacing']['bottomRight']['posY'] - (coneSizeBig[1]), 'w': coneSizeBig[0], 'h': coneSizeBig[1], 'conePos': 'bottomRight', 'hidden': true, 'workoutCone': true});
				
				window['perspectiveDiff'] = Math.abs((canvasH-coneSize[1]) - (canvasH-coneSize[1]*2.5)) / Math.abs((canvasW-coneSize[0]*3) - (canvasW-coneSize[0]*1.5)); */
			}
		else
			{
				workoutCones.forEach(function(item, index) {
					var gridBox = mainthis.gridActions.getGridZone(item['gridBox']-1);
					var imageX = item['gridAlign'] == 'left' ? gridBox['x1'] : gridBox['x2'];
					var imageY = gridBox['y1'];
					var imageSize = mainthis.whiteboard.calculatePerspectiveSize(imageY, item['defaultWidth'], item['defaultHeight']);
					var imageW = imageSize[0];
					var imageH = imageSize[1];
					var conePos = index == 0 ? 'topRight' : index == 1 ? 'topLeft' : index == 2 ? 'bottomLeft' : 'bottomRight';
					
					linePoint.push({'t': 'cone', 'startX': imageX, 'startY': imageY, 'w': imageW, 'h': imageH, 'conePos': conePos, 'hidden': false, 'workoutCone': true});
				});
				
				/* linePoint.push({'t': 'cone', 'startX': (coneSize[0]*3.5)-smallConeDiffW/2, 'startY': canvasH-(coneSize[1]*1.8)-smallConeDiffH, 'w': coneSizeSmall[0], 'h': coneSizeSmall[1], 'conePos': 'topRight', 'hidden': false, 'workoutCone': true});
				linePoint.push({'t': 'cone', 'startX': canvasW-(coneSize[0]*3.5)+smallConeDiffW/2, 'startY': canvasH-(coneSize[1]*1.8)-smallConeDiffH, 'w': coneSizeSmall[0], 'h': coneSizeSmall[1], 'conePos': 'topLeft', 'hidden': true, 'workoutCone': true});
				linePoint.push({'t': 'cone', 'startX': canvasW-(coneSize[0]*1.5)+bigConeDiffW/2, 'startY': canvasH-coneSize[1]-bigConeDiffH, 'w': coneSizeBig[0], 'h': coneSizeBig[1], 'conePos': 'bottomLeft', 'hidden': true, 'workoutCone': true});
				linePoint.push({'t': 'cone', 'startX': (coneSize[0]*1.5)-bigConeDiffW/2, 'startY': canvasH-coneSize[1]-bigConeDiffH, 'w': coneSizeBig[0], 'h': coneSizeBig[1], 'conePos': 'bottomRight', 'hidden': true, 'workoutCone': true}); */
				
				window['perspectiveDiff'] = Math.abs((canvasH-coneSize[1]) - (canvasH-coneSize[1]*2.5)) / Math.abs((canvasW-coneSize[0]*3) - (canvasW-coneSize[0]*1.5));
			}
		
		/* linePoint.forEach(function(item, index) {
			if ( item['workoutCone'] )
				{
					var coneY = parseFloat((((item['startY'] + coneSizeBig[1]) / (canvasH/2)) - 1).toFixed(2));
					if ( coneY < 0.2 ) { coneY = 0.2 } 
					
					var newConeW = Math.round(coneSizeBig[0] * coneY);
					var newConeH = Math.round(coneSizeBig[1] * coneY);
					
					item['w'] = newConeW;
					item['h'] = newConeH;
					item['dist'] = coneY;
					if ( window['workoutConePlacing'] && window['useEquipmentLocation'] ) { item['startY'] = window['workoutConePlacing'][item['conePos']]['posY'] - newConeH; }
				}
		}); */
		
		return linePoint;
	}
	
	placeConesInZone(id) {
		let coneX = 0;
		let posDiffX = 0;
		let posDiffY = 0;
		let canvasW = 1280;
		let canvasH = 720;
		let coneSizeBig = [101, 111];
		
		posDiffX = window['workoutConeLocation'+id]['bottomLeft']['posX'] - window['workoutConeLocation'+id]['topLeft']['posX'];
		let coneX1 = window['workoutConeLocation'+id]['bottomRight']['posX'] + posDiffX;
		let coneX2 = window['workoutConeLocation'+id]['bottomLeft']['posX'] - posDiffX;
			
		if ( window['workoutConeLocation'+id]['bottomRight']['posX'] > (canvasW - window['workoutConeLocation'+id]['bottomLeft']['posX']) )
			{
				posDiffX = window['workoutConeLocation'+id]['topRight']['posX'] - window['workoutConeLocation'+id]['bottomRight']['posX'];
				
				coneX1 = window['workoutConeLocation'+id]['topRight']['posX'] - coneSizeBig[0];
				coneX2 = canvasW - window['workoutConeLocation'+id]['topRight']['posX'];
			}
		else
			{
				coneX1 = canvasW - window['workoutConeLocation'+id]['topLeft']['posX'] - coneSizeBig[0];
				coneX2 = window['workoutConeLocation'+id]['topLeft']['posX'];
			}
			
		if ( (window['workoutConeLocation'+id]['bottomLeft']['posY'] - window['workoutConeLocation'+id]['topLeft']['posY']) > (window['workoutConeLocation'+id]['bottomRight']['posY'] - window['workoutConeLocation'+id]['topRight']['posY']) )
			{
				posDiffY = window['workoutConeLocation'+id]['bottomLeft']['posY'] - window['workoutConeLocation'+id]['topLeft']['posY'];
			}
		else
			{
				posDiffY = window['workoutConeLocation'+id]['bottomRight']['posY'] - window['workoutConeLocation'+id]['topRight']['posY'];
			}
			
		window['canvasLines'+id][window['canvasLines'+id].length-2]['startY'] = window['workoutConeLocation'+id]['topRight']['posY'] - coneSizeBig[1]/2;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['startX'] = coneX2;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['startY'] = window['workoutConeLocation'+id]['topRight']['posY'] - coneSizeBig[1]/2;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['startX'] = coneX1;
		
		var coneY = parseFloat((((window['canvasLines'+id][window['canvasLines'+id].length-2]['startY'] + window['canvasLines'+id][window['canvasLines'+id].length-2]['h']/2) / (canvasH/2)) - 0.7).toFixed(2));
		if ( coneY < 0.2 ) { coneY = 0.2 }
		
		var coneDist = parseFloat(coneY / Math.sqrt(0^2 + 1)).toFixed(2); //Math.sqrt( xDistance^2 + yDistance^2 ) //= Math.sqrt(x^2 + 1) * yDistance;
		var newConeW = Math.round((coneSizeBig[0]) * coneY);
		var newConeH = Math.round((coneSizeBig[1]) * coneY);
		
		window['canvasLines'+id][window['canvasLines'+id].length-2]['w'] = newConeW;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['h'] = newConeH;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['dist'] = coneY;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['w'] = newConeW;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['h'] = newConeH;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['dist'] = coneY;
		
		window['canvasLines'+id][window['canvasLines'+id].length-2]['startY'] = window['canvasLines'+id][window['canvasLines'+id].length-2]['startY'] + coneSizeBig[1]/2 - newConeH/2;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['startY'] = window['canvasLines'+id][window['canvasLines'+id].length-1]['startY'] + coneSizeBig[1]/2 - newConeH/2;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['startX'] = window['canvasLines'+id][window['canvasLines'+id].length-2]['startX'] + coneSizeBig[0]/2 - newConeW/2;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['startX'] = window['canvasLines'+id][window['canvasLines'+id].length-1]['startX'] + coneSizeBig[0]/2 - newConeW/2;
	}
	
	placeDiagConesInZone(id) {
		let canvasW = 1280;
		let canvasH = 720;
		let coneSizeSmall = [76, 85];
		let coneSizeBig = [101, 111];
		
		var coneY = parseFloat((((window['workoutConeLocation'+id]['bottomRight']['posY'] - coneSizeBig[1]/2) / (canvasH/2)) - 0.7).toFixed(2));
		var secondConeY = parseFloat((((window['workoutConeLocation'+id]['topLeft']['posY'] - coneSizeBig[1]/2) / (canvasH/2)) - 0.7).toFixed(2));
		if ( coneY < 0.2 ) { coneY = 0.2 }
		if ( secondConeY < 0.2 ) { secondConeY = 0.2 }
		
		var newConeW = Math.round((coneSizeBig[0]) * coneY);
		var newConeH = Math.round((coneSizeBig[1]) * coneY);
		var secondConeW = Math.round((coneSizeBig[0]) * secondConeY);
		var secondConeH = Math.round((coneSizeBig[1]) * secondConeY);
		
		window['canvasLines'+id][window['canvasLines'+id].length-1]['w'] = newConeW;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['h'] = newConeH;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['dist'] = coneY;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['w'] = secondConeW;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['h'] = secondConeH;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['dist'] = secondConeY;
		
		let coneX1 = window['workoutConeLocation'+id]['bottomRight']['posX'] - newConeW/2;
		let coneY1 = window['workoutConeLocation'+id]['bottomRight']['posY'] - newConeH;
		let coneX2 = window['workoutConeLocation'+id]['topLeft']['posX'] - secondConeW/2;
		let coneY2 = window['workoutConeLocation'+id]['topLeft']['posY'] - secondConeH;
		
		if ( coneX1 < 0 ) { coneX1 = 0; }
		if ( coneX2 > (canvasW - secondConeW) ) { coneX2 = canvasW - secondConeW; }
		
		window['canvasLines'+id][window['canvasLines'+id].length-1]['startX'] = coneX1;
		window['canvasLines'+id][window['canvasLines'+id].length-1]['startY'] = coneY1;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['startX'] = coneX2;
		window['canvasLines'+id][window['canvasLines'+id].length-2]['startY'] = coneY2;
	}
}

export default coneDrawing;